let envDict: any = {};

const envFiles = require.context('@/services/env/', true, /\.(js|ts)$/);
const serviceFiles = require.context('@/services/', true, /\.(js|ts)$/);

envFiles.keys().forEach(key => {
	let filePath: Array<string> = key.match(/[^\/]+/g) as Array<string>;
	const fileName: string = String(filePath.slice(-1)).replace(/\.[^.]+$/, '');

	envFiles(key).default['env'] = fileName;
	envDict[fileName.toLowerCase()] = envFiles(key).default;
});

//否则根据所有环境配置文件的test正则数组来寻找符合当前域名匹配的配置策略;
let env: any = {};
let envMatchLength: number = 0;
let envMatchTest: any = null;
let http: any = {};

const envColl: Array<any> = Object.values(envDict).map(item => {
	(item as any).regexps = (item as any).test.map((reg: any) => {
		if (Object.prototype.toString.call(reg) == '[object String]') {
			const regStr: string = String(reg)
				.toLowerCase()
				.replace(/^\^/, '')
				.replace(/\//g, '\\/')
				.replace(/https?\??/, 'https?');
			return new RegExp('^' + regStr, 'i');
		}
		return reg as RegExp;
	});
	return item;
});

export default http;
export { env };

export function setHref (url: string = ''){
	envColl.forEach((item, index) => {
		item.regexps
			.map((reg: RegExp) => {
				return (url.match(reg) || [ '' ])[0].length;
			})
			.forEach((len: number, regIndex: number) => {
				if (envMatchLength < len) {
					envMatchLength = len;
					envMatchTest = item.test[regIndex];
					env = { ...envColl[index] };
					delete env.regexps;
					delete env.test;
				}
			});
	});
	console.log(env);
	console.log('api: 接口环境匹配方式: 通过 ' + envMatchTest + ' 匹配成功!');
	console.log('api: 接口环境匹配成功, 当前环境:: ' + env.name + ' ::');

	serviceFiles.keys().forEach(key => {
		if (!/^\.\/env/i.test(key)) {
			//不在/services/env/文件夹中的文件被当作http设置文件来使用;
			for (let apiName in serviceFiles(key)) {
				http[apiName] = serviceFiles(key)[apiName];
				http[apiName].api = http[
					apiName
				].api.replace(/(\$\{.+\})(.+)/, (origin: string, path: string, api: string) => {
					const envVar: string = path.replace(/(\$|\{|\})/g, '');
					if (!env[envVar]) {
						console.error(`找不到 [ ${envVar} ] 接口环境变量!`);
						console.error(`请确认此接口api路径配置错误: `, http[apiName]);
					}
					return String(
						env[envVar] + api,
						//使用env环境变量拼接出正确完整的API地址;
					).replace(/([^\/]+\/\/)(.+)/, (origin: string, prefix: string, surfix: string) => {
						//因为是拼接出来的地址,可能出现http://www.yunztech.com//demo/login这种错误地址;
						//所以这里再次使用正则将第二个//开始的双斜线批量替换为/单斜线;
						return prefix + surfix.replace(/\/+/g, '/');
					});
				});
			}
		}
	});
}
